var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99954 6.99952H3.99522C2.89265 6.99952 1.99976 7.89155 1.99976 8.99155V20.0078C1.99976 21.1061 2.89351 21.9999 3.99522 21.9999H18.0048C19.1074 21.9999 20.0003 21.1078 20.0003 20.0078V8.99155C20.0003 7.89327 19.1065 6.99952 18.0048 6.99952H15.0005V8.49998H18.4998V20.5003H3.50022V8.49998H6.99954V6.99952Z",
    fill: "#143CFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 1.00032C11.4142 1.00032 11.7502 1.41454 11.7502 1.75056V13.2506C11.7502 13.6648 11.4142 14.0009 11 14.0009C10.5858 14.0009 10.2498 13.5867 10.2498 13.2506V1.75056C10.2498 1.33635 10.5858 1.00032 11 1.00032Z",
    fill: "#143CFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5303 0.287895C11.8233 0.580935 11.7675 1.11118 11.5303 1.34836L8.34798 4.53066C8.05494 4.8237 7.58056 4.8237 7.28752 4.53066C6.99448 4.23762 7.05033 3.70738 7.28752 3.4702L10.4698 0.287895C10.7629 -0.00514477 11.2372 -0.00514477 11.5303 0.287895Z",
    fill: "#143CFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7125 4.53068C14.4195 4.82372 13.8893 4.76786 13.6521 4.53068L10.4698 1.34838C10.1767 1.05534 10.1767 0.580953 10.4698 0.287913C10.7628 -0.00512661 11.2931 0.0507314 11.5302 0.287913L14.7125 3.47021C15.0056 3.76325 15.0056 4.23764 14.7125 4.53068Z",
    fill: "#143CFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.9e27884c391d804fd72f5704c3fe2522.svg";
export { ForwardRef as ReactComponent };